import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    logoShow: true,
    autoTheme: false,
    dropKey: false
  },
  getters: {
  },
  mutations: {
    setLogo(state, value) {
      state.logoShow = value
    },
    setTheme(state, value) {
      state.autoTheme = value
    }
  },
  actions: {

  },
  modules: {
  }
})
